import { useState, useEffect } from "react";
import TabWordpress from "./TabWordpress";
import TabHtml from "./TabHtml";
import TabReact from "./TabReact";
import TabWebflow from "./TabWebflow";

const tabsData = [
  {
    id: "wordpress",
    label: "Wordpress",
    shortLabel: "Wordpress",
    content: <TabWordpress />,
  },
  {
    id: "webflow",
    label: "Webflow",
    shortLabel: "Webflow",
    content: <TabWebflow />,
  },
  {
    id: "react",
    label: "react",
    shortLabel: "react",
    content: <TabReact />,
  },
  {
    id: "html",
    label: "Vanilla HTML",
    shortLabel: "html",
    content: <TabHtml />,
  },

];

export default function Tabs() {
  const [activeTab, setActiveTab] = useState("wordpress");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="tabs">
      <div className="tabs__head">
        {tabsData.map((tab) => (
          <button
            className={`tabs__head-item ${activeTab === tab.id ? "active-tab" : ""
              }`}
            onClick={() => {
              setActiveTab(tab.id);
            }}
            key={tab.id}
          >
            {isMobile ? tab.shortLabel : tab.label}
          </button>
        ))}
      </div>
      <div className="tabs__content">
        {tabsData.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  );
}
